<template>
    <!-- Add Warehouse Modal -->
    <div class="modal fade" id="addWarehouseModal" ref="addWarehouseModal" tabindex="-1"
         aria-labelledby="warehouseModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 900px;">
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="warehouseModalLabel">
                        <template v-if="warehouse!=null">Edit</template>
                        <template v-else>Add</template>
                        Warehouse
                    </h5>
                    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">&times;</button>
                </div>
                <div class="modal-body" v-if="form">
                    <div class="alert alert-success" role="alert" v-if="successMessage">
                        {{ successMessage }}
                    </div>

                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="javascript:void(0);" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }" ref="formValidation" name="addWarehouse">
                        <form @submit.prevent="handleSubmit(submitHandler)" enctype="multipart/form-data">
                            <div class="contact-dtlbox">
                                <div class="row count_contact contact_1">
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label class="control-label">Location Name</label>
                                                <input type="text" class="form-control"
                                                       id="shipping_location" name="shipping_location"
                                                       v-model="form.name">
                                                <span class="error">{{ errors[0] }}</span>
                                            </div>

                                        </validation-provider>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <GooglePlaceAutoComplete v-if="loadMap"
                                                                     :title="'Address'"
                                                                     :placeholder="'Address'"
                                                                     :errors="errors"
                                                                     v-model="form.address"
                                                                     @selectedEvent="selectGoogleAddress($event)"></GooglePlaceAutoComplete>
                                        </validation-provider>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label
                                                    class="control-label">State </label>
                                                <input type="text" class="form-control"
                                                       name="shipping_state"
                                                       v-model="form.state">
                                                <span class="error">{{ errors[0] }}</span>
                                            </div>
                                        </validation-provider>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label
                                                    class="control-label">City </label>
                                                <input type="text" class="form-control"
                                                       name="shipping_city" v-model="form.city">
                                                <span class="error">{{ errors[0] }}</span>
                                            </div>
                                        </validation-provider>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
                                        <validation-provider rules="required" v-slot="{ errors }">
                                            <div class="form-group">
                                                <label
                                                    class="control-label">Zip </label>
                                                <input type="text" class="form-control"
                                                       name="shipping_zip"
                                                       v-model="form.post_code">
                                                <span class="error">{{ errors[0] }}</span>
                                            </div>
                                        </validation-provider>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                        <div class="customremove d-flex">
                                            <div class="form-group d-flex">
                                                <input type="checkbox" v-model="form.is_default"
                                                       name="default_contact">
                                                <label class="mdl-textfield__label">Default address </label>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                        <div class="customremove d-flex">
                                            <div class="form-group d-flex">
                                                <input type="checkbox" v-model="form.is_saved"
                                                       name="is_saved">
                                                <label class="mdl-textfield__label">Save to DB</label>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="mt-3 text-end">
                                <button type="submit" :disabled="loading" class="btn btn-primary fw-semibold fs-14 px-4">
                                    Add
                                </button>
                            </div>
                        </form>
                    </ValidationObserver>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {ValidationProvider, ValidationObserver, extend, configure} from 'vee-validate';
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";
import GooglePlaceAutoComplete from "../components/GooglePlaceAutoComplete";

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});

extend('positive', value => {
    if (value >= 0) {
        return true;
    }

    return 'This field must be a positive number';
});

export default {
    name: "AddWarehouse",
    props: ['warehouse', 'loading', 'bus', 'customerId', 'warehouseAddType'],
    components: {
        ValidationObserver, ValidationProvider,
        GooglePlaceAutoComplete
    },
    created() {
    },
    mounted() {
        let self = this;

        $("#addWarehouseModal").on('show.bs.modal', () => {
            this.loadMap = true;
            self.form.customerId = self.customerId;
            self.form.warehouseAddType = self.warehouseAddType;
            if (self.warehouse) {
                self.form.id = self.warehouse.id;
                self.form.is_default = self.warehouse.is_default;
                self.form.address2 = self.warehouse.address2;
                self.form.address = self.warehouse.address;
                self.form.state = self.warehouse.state;
                self.form.city = self.warehouse.city;
                self.form.post_code = self.warehouse.post_code;
            }
        });

        $('#addWarehouseModal').on('hidden.bs.modal', function () {
            self.form = {
                id: null,
                is_default: false,
                address2: null,
                address: null,
                state: null,
                city: null,
                post_code: null,
                is_saved: false,
                customerId: null,
                warehouseAddType: null
            };
            self.$refs.formValidation.reset();

            self.$emit('closedModal');
        });
    },
    data() {
        return {
            loadMap: false,
            form: {
                id: null,
                name:null,
                is_default: false,
                address2: null,
                address: null,
                state: null,
                city: null,
                post_code: null,
                is_saved: false,
                customerId: null,
                warehouseAddType: null
            },
        };
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        submitHandler() {
            this.$refs.formValidation.validate().then(success => {
                if (!success) {
                    return;
                }

                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);

                if (this.warehouse) {
                    return axios.put(window.route('warehouses.update', {id: this.form.id}), this.form, {

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage('Warehouse updated');
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('updatedEvent', data.data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                } else {
                    return axios.post(window.route('warehouses.store'), this.form, {

                        validateStatus: function (status) {
                            return status < 500; // Resolve only if the status code is less than 500
                        }
                    })
                        .then(({data}) => {
                            if (data.errors && Object.keys(data.errors).length) {
                                self.setCommonErrors(data.errors);
                            } else if (data.errorMessage) {
                                self.setErrorMessage(data.errorMessage);
                            } else {
                                self.setSuccessMessage('Warehouse added');
                                setTimeout(() => {
                                    self.setSuccessMessage(null);
                                }, 5000);
                                self.$emit('addedEvent', data.data);
                            }
                        })
                        .catch((error) => {
                            self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                        })
                        .finally(() => {
                            self.setLoading(false);

                        });
                }
            });
        },
        selectGoogleAddress(place) {
            
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            let country = place.address_components.find((x) => x.types.includes('country'));

            let address = '';
            if (neighborhood) {
                address += neighborhood.long_name;
            }
            if (sublocality) {
                address += address.length > 0 ? ', ' : '';
                address += sublocality.long_name;
            }
            if (locality) {
                address += address.length > 0 ? ', ' : '';
                address += locality.long_name;
            }

            if (address == '') {
                address = place.formatted_address;
            }

            if (place.name != '') {
                if (!this.form.address2 || this.form.address2 === '') {
                    this.form.address2 = "";
                }
                this.form.address = place.name;
            } else {
                this.form.address = address;
            }

            this.form.post_code = null;
            if (pinCode) {
                this.form.post_code = pinCode.long_name;
            }
            this.form.city = null;
            if (city) {
                this.form.city = locality.long_name;
            }
            this.form.state = null;
            if (state) {
                this.form.state = state.short_name;
            }

        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {}
}
</script>

<style scoped>

</style>
